import { Link } from "react-router-dom";

export default function EventDetailModal({ event, onClose }) {
  if (!event) return null;

  const { extendedProps, start, end } = event;

  const { experience_title, members = [], experience_url_slug ,experience_id, image, baseURL} = extendedProps;
  const formattedDate = new Date(start).toLocaleDateString("en-GB");
  const startTime = new Date(start).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const endTime = new Date(end).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  return (
    <div  id="event_modal">
      <div className="modal-dialog-centered">
      <div className="eventundermodal">
        <button
          onClick={onClose}
          className="closed"
        >
          ✕
        </button>
        <div className="modal_content">
          <img className="modal_img" src={`${baseURL}${image}`} alt="Experience" />
          <h2 className="modal_title"><span className="name_exp">{experience_title}</span>
            <p className="modal_slot">
          <strong>Experience Slot:</strong> {formattedDate}, {startTime} - {endTime}
        </p>
          </h2>
          

        </div>
        
        

      <div className="modal_members_section">
         <h4 className="modal_subtitle">Confirmed Members</h4>
          <ul className="modal_member_list">
         <ul className="modal_member_list">
  {members.map((m, i) => {
    const parts = [];

    if (m.adults > 0) parts.push(`${m.adults} Adult${m.adults > 1 ? "s" : ""}`);
    if (m.children > 0) parts.push(`${m.children} Child${m.children > 1 ? "ren" : ""}`);
    if (m.infants > 0) parts.push(`${m.infants} Infant${m.infants > 1 ? "s" : ""}`);

    return (
      <li key={i}>
        {m.name} ({parts.join(", ")})
      </li>
    );
  })}
</ul>

        </ul>
        </div>

        <div className="modal_view_section">
        <Link
                to={`/experience/${experience_url_slug}`}
                className="modal_view_link"
              >
                View
              </Link>
            </div>
      </div>
    </div>
    </div>
  );
}
